
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('span', {
                        'className': 'badge cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n          ', badge, '\n        ');
                }
                function scopeProduct2() {
                    var product = this.productData ?? this;
                    return [product.is_autosync_allowed ? _createElement('button', {
                            'className': 'cm_view-on-vehicle-btn button button--secondary',
                            'onClick': () => window.Convermax.openAutoSyncDialog(product.autosync_id, product.autosync_mpn, product.FitmentType?.includes('Tire')),
                            'type': 'button',
                            'key': '48251'
                        }, '\n    ', _translate(`view_product_on_vehicle`), '\n  ') : null];
                }
                return _createElement('li', { 'className': 'grid-item' + (this.is_promotional_item ? ' cm_promotion' : '') }, _createElement('div', { 'className': 'card card-product' }, _createElement('figure', { 'className': 'card-media' + (this.variant_ids.length > 1 ? ' multiple-variants' : '') }, _createElement('a', { 'href': this.url }, _createElement('img', {
                    'className': 'card-media-image',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError,
                    'width': '190',
                    'height': '200',
                    'loading': 'lazy'
                })), _createElement.apply(this, [
                    'div',
                    { 'className': 'card-badge top left' },
                    this.on_sale ? _createElement('span', {
                        'className': 'badge badge-sale',
                        'key': '530'
                    }, 'Sale') : null,
                    this._badges ? _map(this._badges, repeatBadge1.bind(this)) : null
                ])), _createElement('div', { 'className': 'card-info' }, _createElement('div', { 'className': 'card-eyebrow' }, this.vendor && this.vendor_url ? _createElement('a', Object.assign({}, {
                    'href': this.vendor_url,
                    'title': this.removeHTML(this.vendor),
                    'key': '868'
                }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })) : null), _createElement('h3', { 'className': 'card-heading typography-body' }, _createElement('a', Object.assign({}, { 'href': this.url }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })))), _createElement('div', { 'className': 'card-footer' }, _createElement('div', { 'className': 'card-footer-intro' }, !this.out_of_stock ? _createElement('div', {
                    'className': 'badge-stock badge-stock-in',
                    'key': '1429'
                }, _createElement('span', { 'className': 'badge-stock-dot' }), ' In stock\n        ') : null, this.out_of_stock ? _createElement('div', {
                    'className': 'badge-stock badge-stock-out',
                    'key': '1571'
                }, _createElement('span', { 'className': 'badge-stock-dot' }), ' ', _translate(`product_out_of_stock`), '\n        ') : null), _createElement('div', { 'className': 'price' }, _createElement('div', { 'className': 'price-container' }, !this.on_sale ? _createElement('div', {
                    'className': 'price-regular',
                    'key': '1822'
                }, _createElement('span', { 'className': 'visually-hidden' }, 'Regular price'), _createElement('span', { 'className': 'price-item price-item-regular' }, this.formatPrice(this.price)), this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'price-item--set',
                    'key': '2041'
                }, '\n              ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n            ') : null) : null, this.on_sale ? _createElement('div', {
                    'className': 'price-sale',
                    'key': '2286'
                }, _createElement('s', { 'className': 'price-item price-item-regular' }, this.formatPrice(this.compare_at_price)), _createElement('span', { 'className': 'price-item price-item-sale price-item-last' }, ' ', this.formatPrice(this.price), ' '), this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'price-item--set',
                    'key': '2552'
                }, '\n              ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n            ') : null) : null)), this.out_of_stock || this.variant_ids.length === 1 && (!this.ProductScope || this.ProductScope === 'child') ? _createElement('div', { 'key': '2822' }, _createElement('form', {
                    'method': 'post',
                    'action': '/cart/add',
                    'id': 'product-form-' + this.id,
                    'acceptCharset': 'UTF-8',
                    'className': 'shopify-product-form',
                    'encType': 'multipart/form-data',
                    'noValidate': 'novalidate',
                    'data-type': 'add-to-cart-form'
                }, _createElement('input', {
                    'type': 'hidden',
                    'name': 'form_type',
                    'value': 'product'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'utf8',
                    'value': '\u2713'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'id',
                    'value': this.variant_ids[0]
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'quantity',
                    'value': this.set_qty || 1
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'product-id',
                    'value': this.id
                }), this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                    'type': 'hidden',
                    'name': 'properties[Fitment]',
                    'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                    'key': '3529'
                }) : null, _createElement('div', { 'className': 'product-actions card-product-actions' }, _createElement('div', { 'className': 'product-actions-add-to-cart' }, _createElement('button', {
                    'type': 'submit',
                    'name': 'add',
                    'className': 'button button-outline button-add-to-cart',
                    'disabled': this.out_of_stock
                }, _createElement('span', {}, this.out_of_stock ? [_translate(`product_out_of_stock`)] : null, !this.out_of_stock ? [
                    _translate(`product_add_to_cart`),
                    this.set_qty ? ` ${ _translate(`product_set_of`, {  count: this.set_qty  }) }` : '',
                    '\n                  '
                ] : null)))))) : null, !this.out_of_stock && this.variant_ids.length > 1 || this.ProductScope === 'master' ? _createElement('div', {
                    'className': 'product-actions card-product-actions',
                    'key': '4444'
                }, _createElement('div', { 'className': 'product-actions-add-to-cart' }, _createElement('a', {
                    'href': this.url,
                    'className': 'button button-outline js-product-link'
                }, _translate(`product_select_options`)))) : null, [scopeProduct2.apply(this, [])]), this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '5253'
                }) : null));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement('div', { 'className': 'scroller' }, _createElement('div', { 'className': 'scroller-inner' }, _createElement.apply(this, [
        'div',
        { 'className': 'grid grid-3-col-tablet grid-4-col-desktop cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]))));
}
        export const componentNames = []